import BackToPreviousPageButton from "../shared/buttons/BackToPreviousPageButton";
import { ApplicationWithId } from "../../interfaces/IApplications";
import { Box, Stack, Typography } from "@mui/material";
import { ContestWithId } from "../../interfaces/IContests";

interface ApplicationHeaderProps {
  application: ApplicationWithId;
  contest?: ContestWithId;
}

export default function ApplicationHeader({ application, contest }: ApplicationHeaderProps) {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={{ ml: 3, fontWeight: 600, color: "#2f2f2f" }}>
          Zgłoszenie na: {contest?.name || application?.contestName}
        </Typography>
        <BackToPreviousPageButton to="/contests" title="Powrót do listy zgłoszeń" />
      </Stack>
    </Box>
  );
}
